import type { EliminationBoundary, SpaceConfig } from "../types/space";

export function getEliminationBoundary(
  config: SpaceConfig,
): EliminationBoundary {
  return {
    minX: -config.boundaryPadding,
    minY: -config.boundaryPadding,
    maxX: config.cols - 1 + config.boundaryPadding,
    maxY: config.rows - 1 + config.boundaryPadding,
  };
}

export function isOutOfBounds(
  x: number,
  y: number,
  boundary: EliminationBoundary,
): boolean {
  return (
    x < boundary.minX ||
    x > boundary.maxX ||
    y < boundary.minY ||
    y > boundary.maxY
  );
}
